import ChannelListBlock from '@components/elements/channelList/channelListBlock';
import ChannelListContext from '@shared/components/utils/context/channelListContext';
import ChannelListDescriptionContainer from '@components/atoms/container/channelListDescriptionContainer';
import ChannelListSynopsis from '@components/elements/channelList/channelListSynopsis';
import { useContext } from 'react';

export default function ChannelListDescription() {
  const { focused } = useContext(ChannelListContext);

  return (
    <ChannelListDescriptionContainer
      focused={focused}
      id={'channelListDescriptionContainer'}
    >
      <ChannelListBlock />
      <ChannelListSynopsis />
    </ChannelListDescriptionContainer>
  );
}
